export const openingStockDraftKey = (account, warehouse) => account && warehouse
  ? `opening-stock-draft:v1:${account}:${warehouse}` : null;
export function readOpeningStockDraft(key) {
  if (!key) return null;
  try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; }
}
export function saveOpeningStockDraft(key, draft) {
  if (!key) throw new Error('Sign in and select a warehouse before saving.');
  localStorage.setItem(key, JSON.stringify(draft));
}
